// noinspection JSIgnoredPromiseFromCall

import "@fortawesome/fontawesome-free/css/all.css";
import "../scss/app.scss";
import "cqfill";
import getConfig, {updateConfig} from "./config";
import {setupFancybox} from "./fancybox";
import {setupEvents} from "./events";
import {initDatepicker} from "./datepicker";

const config = getConfig();
const domLoaded = async () => {
    updateViewportUnits();
    setupFancybox();
    await setupEvents();

    const emptyElsExceptions = [
        "area",
        "audio",
        "audio *",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "iframe",
        "img",
        "input",
        "link",
        "meta",
        "object",
        "object *",
        "param",
        "select *",
        "source",
        "svg *",
        "track",
        "video",
        "video *",
        "wbr",
        ".datepicker",
    ].join(", ");
    [
        ...document.querySelectorAll(`#main *:not(${emptyElsExceptions})`),
    ].forEach((el) => {
        if (0 < el.children.length) {
            return;
        }

        const trimmedText = el.textContent.trim();

        if ("" === trimmedText) {
            el.textContent = trimmedText;
            el.classList.add("empty");
        }
    });
};
const loadResize = () => {
    updateViewportUnits();
};

const updateViewportUnits = () => {
    document.documentElement.style.setProperty(
        "--vw",
        `${(window.innerWidth / 100).toFixed(2)}px`,
    );
    document.documentElement.style.setProperty(
        "--vw-unit",
        `${(document.documentElement.clientWidth / 100).toFixed(2)}px`,
    );
    document.documentElement.style.setProperty(
        "--vh",
        `${(window.innerHeight / 100).toFixed(2)}px`,
    );
    document.documentElement.style.setProperty(
        "--vh-unit",
        `${(document.documentElement.clientHeight / 100).toFixed(2)}px`,
    );
};

const init = (config = {}) => {
    updateConfig(config);
    initDatepicker();

    if ("loading" === document.readyState) {
        document.addEventListener("DOMContentLoaded", domLoaded);
    } else {
        domLoaded();
    }

    addEventListener("load", loadResize);
    addEventListener("resize", loadResize);
};

let appNameVarSafe = config.appName.replace(/[_-]([a-z])/g, (substr, letter) =>
    letter.toUpperCase(),
);
appNameVarSafe = appNameVarSafe.replace(/[_-]/g, "");
const globalConfigName = appNameVarSafe + "Config";
const globalConfig = window[globalConfigName] ?? {};
init(globalConfig);
window[appNameVarSafe + "GetConfig"] = getConfig;
